<template>
  <wc-dialog
      :showDialog='show_legend_dialog'
      title='Project Row Legend'
      hideCancel
      saveText='Close'
      @save='closeLegendDialog'
      width='600'
    >
      <template v-slot:fullWidth>
        <v-card-text>
          <span class='grey--text text--darken-3 font-weight-bold'>Project is ready for processing</span><br>
          <span class='red--text text--darken-1 font-weight-bold'>Project has conflicts</span><br>
          <span class='success--text font-weight-bold'>Project Staging is complete</span><br>
          <span class='grey--text text--lighten-1 font-weight-bold'>Project is cancelled/declined</span><br>
          <br>
          
          <v-icon class='mr-3' color="info">mdi-snail</v-icon>
          <span class='font-weight-bold'>Snail Mail Only</span><br>
          <span class='caption ml-9'>The Project Notices Contact has this setting</span><br><br>
          
          <v-icon class='mr-3' color="warning">mdi-alert-circle-outline</v-icon>
          <span class='font-weight-bold'>Project has conflicts, but is currently set to cancelled</span><br>
          <span class='caption ml-9'>These projects are not included in the column conflict count</span><br><br>

          <v-icon class='mr-3' color="error">mdi-alert-circle-outline</v-icon>
          <span class='font-weight-bold'>Project has fatal conflicts, but is currently set to cancelled</span><br>
          <span class='caption ml-9'>These projects are not included in the column fatal conflict count</span><br><br>
          
          <v-icon class='mr-3' color="warning">mdi-debug-step-over</v-icon>
          <span class='font-weight-bold'>Project is set to ignore conflicts</span><br>
          <span class='caption ml-9'>These projects are not counted in the column conflict count</span><br><br>

          <v-icon class='mr-3' color="grey">mdi-debug-step-over</v-icon>
          <span class='font-weight-bold'>Project is set to ignore conflicts (but none are currently present)</span><br>
          <span class='caption ml-9'>This setting will be automatically removed if a project gains a fatal conflict</span><br><br>
          
          <v-icon class='mr-3' color="primary">mdi-timer-outline</v-icon>
          <span class='font-weight-bold'>Project is set to Quick Pay</span><br>
          <span class='caption ml-9'>This setting can only be changed on the project page (not in staging)</span>

        </v-card-text>
      </template>
  </wc-dialog>
</template>

<script>
export default {
  name: 'staging-legend',
  props: {
    show_legend_dialog: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  methods: {
    closeLegendDialog(){
      this.$emit('showLegendDialog', false);
    }
  }
}
 
</script>